import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

import Forms from '@/store/modules/forms'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialogMain: {
      dialog: false,
      type: '',
      form: '',
      withWindows: 500,
      title: ''
    },
    urls: null,
    logos: null,
    responseCaptchar: null,
    object: {},
    objectTwo: {},
    objectAccess: {},
    objectExport: {},
    objects: [],
    objectsSecound: [],
    options: {},
    model: {},
    objectFind: null,
    objectImport: {},
    objectPagination: {},
    reload: {},
    loading: false
  },
  getters: {
    get_dialogMain (state) { return state.dialogMain },
    get_urls (state) { return state.urls },
    get_logos (state) { return state.logos },
    get_responseCaptchar (state) { return state.responseCaptchar },
    get_objectFind (state) { return state.objectFind },
    get_object (state) { return state.object },
    get_objectTwo (state) { return state.objectTwo },
    get_objectAccess (state) { return state.objectAccess },
    get_objectExport (state) { return state.objectExport },
    get_objects (state) { return state.objects },
    get_objectsSecound (state) { return state.objectsSecound },

    get_options (state) { return state.options },
    get_model (state) { return state.model },
    get_objectImport (state) { return state.objectImport },
    get_objectPagination (state) { return state.objectPagination },
    get_reload (state) { return state.reload },
    get_loading (state) { return state.loading }
  },
  mutations: {
    SHOW_DIALOG_MAIN (state, data) {
      state.dialogMain.dialog = true
      state.dialogMain.type = data.type
      state.dialogMain.form = (data.form) ? data.form : 'form'
      state.dialogMain.withWindows = (data.with) ? data.with : 700
      state.dialogMain.title = (data.title) ? data.title : 'Sin Titulo'
    },
    HIDDE_DIALOG_MAIN (state) {
      state.dialogMain.dialog = false
      state.dialogMain.type = ''
    },
    CLEAR_OBJECT (state) {
      state.object = {}
    },
    CLEAR_OBJECTS (state) {
      state.objects = []
    },
    CLEAR_OBJECTS_OPTIONS (state) {
      state.options = {}
    },
    CLEAR_OBJECTS_MODEL (state) {
      state.model = {}
    },
    SET_LOADING_STATUS (state, data) {
      state.loading = data
    },

    SET_DATA_OBJECT_FIND (state, data) {
      state.objectFind = data
    },
    SET_DATA_OBJECT (state, data) {
      let findobject = -1
      state.objects.map((el, i) => {
        if (el.id === data.id) {
          findobject = i
        }
      })
      if (findobject !== -1) {
        Object.assign(state.objects[findobject], data)
      } else {
        state.objects.push(data)
      }
    },
    RELOAD_DATA_OBJECT (state, data) {
      state.reload = data
    },
    SET_DATA_OBJECT_UPDATE (state, data) {
      let findobject = -1
      state.objects.map((el, i) => {
        if (el.id === data.id) {
          findobject = i
        }
      })
      if (findobject !== -1) {
        Object.assign(state.objects[findobject], data)
      }
    },
    // ======| MEtHODS DELETE |======
    DELETE_DATA_OBJECT_PAGINATION (state, data) {
      state.objectPagination.data = state.objectPagination.data.filter(el => el.id !== data.id)
      state.objectPagination.total -= 1
    },
    DELETE_DATA_OBJECT (state, data) {
      state.objects = state.objects.filter(el => el.id !== data.id)
    },
    // ===============
    OPTION_NEXT_ACTION (state, options) {
      state.options = {}
      state.options = options
    },
    EXECUTE_ACTION (state, action) {
      state.model = {}
      state.model = action
    },
    // ===============
    GET_URLS_SERVER (state, urls) {
      state.urls = {}
      state.urls = urls
    },
    GET_DATA_SERVER_LOGO_ICON (state, logos) {
      state.logos = {}
      state.logos = logos
    },
    GET_DATA_CAPTCHAR (state, response) {
      state.responseCaptchar = {}
      state.responseCaptchar = response
    },
    // ===============
    POST_DATA_SERVER_LOGIN (state, data) {
      state.objectAccess = {}
      state.objectAccess = data
    },
    POST_DATA_SERVER (state, data) {
      state.object = {}
      state.object = data
    },
    GET_DATA_SERVER_TWO (state, data) {
      state.objectTwo = {}
      state.objectTwo = data
    },
    GET_DATA_SERVER_LIST (state, data) {
      state.objects = []
      state.objects.push(...data)
    },
    GET_DATA_SERVER_LIST_SECOUND (state, data) {
      state.objectsSecound = []
      state.objectsSecound.push(...data)
    },
    POST_DATA_EXPORT_SERVER (state, exp) {
      state.objectExport = {}
      state.objectExport = exp
    },
    POST_DATA_IMPORT_SERVER (state, data) {
      state.objectImport = {}
      state.objectImport = data
    },
    GET_DATA_SERVER_LIST_PAGINATION (state, data) {
      state.objectPagination = {}
      state.objectPagination = data
    }
  },
  actions: {
    getUrlServices ({ commit }) {
      axios.post('/app/rutas').then(response => {
        commit('GET_URLS_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlGetIconLogoAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      let params = ''
      if (action.params) {
        action.url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.get(`${action.url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        Vue.$cookies.remove('logos')
        Vue.$cookies.set('logos', response.data.descripcion)
        commit('GET_DATA_SERVER_LOGO_ICON', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlPostServiceLoginAction ({ commit }, action) {
      axios.post(`${action.url}`, action.data).then(response => {
        commit('POST_DATA_SERVER_LOGIN', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlPostActionCaptchar ({ commit }, action) {
      axios.post(action.url, action.data).then(response => {
        commit('GET_DATA_CAPTCHAR', response.data)
      })
        .catch(error => {
          console.log('error', error)
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlPostServiceLogoutAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('POST_DATA_SERVER_LOGIN', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    // Actions with Token
    urlPostServicesAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('POST_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlPostServicesActionSecound ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_TWO', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlPostServicesActionPagination ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_LIST_PAGINATION', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    urlGetServicesActionList ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      let params = ''
      if (action.params) {
        action.url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.get(`${action.url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_LIST', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postServiceListAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_LIST', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlGetServicesActionListSecound ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_LIST_SECOUND', response.data)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },

    urlGetServicesActionOne ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      let params = ''
      if (action.params) {
        action.url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.get(`${action.url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('POST_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    urlGetServiceActionTwo ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      let params = ''
      if (action.params) {
        action.url = action.url.replace(action.replace, '')
        params = action.params
      }
      axios.get(`${action.url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_DATA_SERVER_TWO', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    postUrlImportDataServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('POST_DATA_EXPORT_SERVER', response.data)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },

    //
    getFormServicesAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      if (action.params) {
        action.url = action.url.replace('/{procss}[/{id}]', '')
      }
      axios.get(`${action.url}${action.params}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          commit('OPTION_NEXT_ACTION', response.data)
        })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postExecuteAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          commit('EXECUTE_ACTION', response.data)
        })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    updateExecuteAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.put(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          commit('EXECUTE_ACTION', response.data)
        })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    postUrlImportCatalogDataServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      const formData = new FormData()
      formData.append('file', action.data)
      formData.append('tipoActividadId', action.tipoActividadId)
      const boundary = `; boundary=${formData._boundary}`

      axios.post('/import/catalogos', formData, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' + boundary } })
        .then(response => {
          commit('POST_DATA_IMPORT_SERVER', response.data)
        })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    DeletePaginationServerAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      if (action.params) action.url = action.url.replace(action.replace, action.params)

      axios.delete(action.url, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('DELETE_DATA_OBJECT_PAGINATION', response.data)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    }
  },
  modules: {
    Forms
  }
})
